import React from 'react';
import { Row, Col } from 'react-bootstrap';

import FieldTextAreaWithRating from './FieldTextAreaWithRating.jsx';

export default function TrackRatingSection(props) {
  return (
    <Row>
      <Col xs={12}>
        <h4 className="rating-type">{props.title}</h4>
      </Col>
      { props.fields.map((item, i) => (
        <Col md={6} xs={12} key={item.label}>
          <FieldTextAreaWithRating
            label={`${i + (props.questionNumberOffset || 0) + 1}) ${item.label}`}
            description={item.description}
            ratingField={`${item.name}.rating`}
            textAreaField={`${item.name}.feedback`}
            placeholder="Feedback"
            limit={props.limit || 5}
          />
        </Col>
      ))}
    </Row>
  );
}
